'use client';

export { default } from './Textarea';
export * from './TextareaProps';
export { default as textareaClasses } from './textareaClasses';
export * from './textareaClasses';